import { render } from "./pContent.vue?vue&type=template&id=21501d24&ts=true"
import script from "./pContent.vue?vue&type=script&lang=ts"
export * from "./pContent.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__